import { Component, Input, OnInit } from '@angular/core';
import { HelperService, HTTPService } from 'app/services';
import { DialogService } from 'primeng/dynamicdialog';
import { IDriver } from './driver-side-list.interface';

@Component({
  selector: 'app-driver-side-list',
  templateUrl: './driver-side-list.component.html',
  styleUrls: ['./driver-side-list.component.scss'],
  providers: [DialogService],
})
export class DriverSideListComponent implements OnInit {
  @Input() customer: any = '';
  @Input() drivers: IDriver[] = []; // Typed the drivers as IDriver[]
  @Input() isLoadingAppointment = false; // Default boolean values don't need explicit types
  @Input() isMarketingEnabled = false;
  @Input() appointments: any[] = [];
  @Input() estimate: any;
  @Input('vehicles')
  set vehicles(data: any[]) {
    if (data?.length) {
      this._vehicles = data;
    }
  }

  _vehicles: any[] = [];
  customerAppointments: any;
  driverLength = 0;

  addDriver: IDriver = {
    _id: '',
    isActive: true,
    fullName: '',
    email: '',
    phone: '',
    employeeNumber: null,
    serviceCardNumber: null,
    companyName: '',
    department: '',
    showForm: true,
    customerId: '',
    address: {
      addLine1: '',
      city: '',
      state: '',
      stateCode: '',
      zip: '',
      country: '',
    },
  };

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
  ) {}

  ngOnInit(): void {}

  isValidAddDriver(): boolean {
    return !!this.drivers.find((driver) => !driver?.fullName);
  }

  onAddDriver(): void {
    // Add a new driver form at the top of the list
    this.drivers.unshift({ ...this.addDriver, address: { ...this.addDriver.address }, showForm: true });
  }

  async getAllDrivers(): Promise<void> {
    try {
      const drivers = await this.httpService.getCustomerDrivers(this.customer._id);
      drivers.forEach((driver) => {
        if (!driver.isActive) driver.disabled = true;
      });
      this.drivers = drivers;
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  toggleForm(index: number) {
    this.drivers[index].showForm = !this.drivers[index].showForm;
  }
}
